var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Helper from "@ember/component/helper";
import RouterService from "@ember/routing/router-service";
import { service } from "@ember/service";
import SemeiaSessionService from "core/services/session";
export function route(sourceJeId, asModal = false, session) {
  let route;
  if (session.medic) {
    if (asModal) {
      route = "medics-web.protected.patients.patient.dashboard.main.feature.component";
    } else {
      route = "medics-web.protected.patients.patient.feature.component";
    }
  } else if (session.patient) {
    route = "patient-web.protected.feature.component";
  } else {
    return;
  }
  if (sourceJeId) {
    route += ".edition";
  }
  return route;
}
export function models(feature, component, patient, sourceJeId, session) {
  if (session.patient) {
    return sourceJeId ? [feature, component, sourceJeId] : [feature, component];
  }
  return sourceJeId ? [patient, feature, component, sourceJeId] : [patient, feature, component];
}
/**
 * An helper to directly transition to a forc from a template.
 * @example
 * onClick={{transition-to-forc 'weight' 'edition-form"
 *   @patient someJe.id true}}
 */
let TransitionToForc = (_class = class TransitionToForc extends Helper {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
    _initializerDefineProperty(this, "router", _descriptor2, this);
  }
  compute([feature, component], {
    patient,
    ...queryParams
  }) {
    return () => {
      if (!this.session.medic && !this.session.patient) {
        throw new Error("unknown user type, cannot transition");
      }
      this.router.transitionTo(route(queryParams.sourceJeId, queryParams.asModal, this.session), ...this.params(feature, component, patient, queryParams));
    };
  }
  params(feature, component, patient, queryParams) {
    const params = models(feature, component, patient, queryParams.sourceJeId, this.session);
    params.push({
      queryParams
    });
    return params;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { TransitionToForc as default };